export { default as Cdn } from './Cdn'

import Cdn from './Cdn'
export default {
  Cdn
}
